import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserPermissionsService } from '../../user-permissions.service';
import { TargetService } from 'src/app/sidenav/target.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { catchError, map, Observable, of, Subscription } from 'rxjs';
import { SeoService } from 'src/app/seo/seo.service';
import { TranslateService } from '@ngx-translate/core';
import { SidenavService } from 'src/app/sidenav/sidenav.service';
import { CoreTargetService } from 'src/app/core/services/target.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-user-action',
  templateUrl: './user-action.component.html',
  styleUrls: ['./user-action.component.css'],
})
export class UserPermissionsActionComponent implements OnInit, OnDestroy {
  constructor(
    public dialogRef: MatDialogRef<UserPermissionsActionComponent>,
    private service: UserPermissionsService,
    private fb: FormBuilder,
    private seoService: SeoService,
    public targetService: TargetService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService,
    private sidenavService: SidenavService,
    private coreTargetService: CoreTargetService,
    private localStorageService: LocalStorageService,
    private notificationService: NotificationService
  ) {
    const email: string = this.localStorageService.get('email') || '';

    this.isBehamicsUser = email.endsWith('@behamics.com') || false;

    this.isWhiteLabel = this.localStorageService.get('isWhiteLabel') || false;
    this.isMasterRole = this.localStorageService.get('role') == 'master';

    if (this.data.email != null) {
      this.form = this.fb.group({
        name: [this.data.name, Validators.required],
        email: [this.data.email, Validators.required],
        product: [this.data.product, Validators.required],
        seoProjects: [''],
        role: [''],
        targets: [this.selectedStore, Validators.required],
        adsProjects: [''],
        adsRole: [''],
        isMaster: [false],

        ...(this.isBehamicsUser || (this.isWhiteLabel && this.isMasterRole)
          ? {
              isPremiumSubscription: [this.data.isPremiumSubscription || false],
              // billingInterval: [
              //   this.data.billingInterval || '',
              //   Validators.required,
              // ],
              // organicKeywordsNum: [
              //   this.data.organicKeywordsNum || '',
              //   Validators.required,
              // ],
              // price: [this.data.price || '', Validators.required],
              // forOrganic: [this.data.forOrganic || false],
            }
          : {}),
      });
    } else {
      this.form = this.fb.group({
        name: ['', Validators.required],
        email: ['', Validators.required],
        product: ['', Validators.required],
        seoProjects: [''],
        role: [''],
        targets: ['', Validators.required],
        adsProjects: [''],
        adsRole: [''],
        isMaster: [false],
        ...(this.isBehamicsUser || (this.isWhiteLabel && this.isMasterRole)
          ? {
              isPremiumSubscription: [false],
              // billingInterval: ['', Validators.required],
              // organicKeywordsNum: ['', Validators.required],
              // price: ['', Validators.required],
              // forOrganic: [false],
            }
          : {}),
      });
    }

    this.userActionsSub = new Subscription();
  }

  @ViewChild('seoProjects') seoProjectsSelect: any;
  @ViewChild('product') productSelect: any;

  @ViewChild('adsProjects') adsProjectsSelect: any;

  userActionsSub: Subscription;

  form: FormGroup;
  isNew: any;
  oldData: any;
  formValueChanged = false;
  roleList: any = [
    {
      value: 'seo_manager',
      viewValue: 'Manager',
      viewValueTranslated: 'words.manager',
    },
    ...(this.localStorageService.get('isWhiteLabel') || false
      ? [
          {
            value: 'marketing_officer',
            viewValue: 'Marketing Officer',
            viewValueTranslated: 'words.marketing_officer',
          },
        ]
      : []),
    {
      value: 'seo_content_writer',
      privileges: ['seo_getting_started', 'seo_content'],
      viewValue: 'Content Writer',
      viewValueTranslated: 'words.content_writer',
    },
    {
      value: 'seo_backlink_provider',
      viewValue: 'Backlink Provider',
      viewValueTranslated: 'words.backlink_provider',
    },
  ];
  adsRoleList: any = [
    {
      value: 'ads_manager',
      viewValue: 'Manager',
      viewValueTranslated: 'words.manager',
    },
    // {
    //   value: 'ads_content_writer',
    //   privileges: ['copilot_ads', 'ads_projects'],
    //   viewValue: 'Content Writer',
    //   viewValueTranslated: 'words.content_writer',
    // },
    // {
    //   value: 'ads_backlink_provider',
    //   viewValue: 'Backlink Provider',
    //   viewValueTranslated: 'words.backlink_provider',
    // },
  ];
  billingIntervalList: any = [
    { value: 'monthly', viewValue: 'Monthly' },
    { value: 'yearly', viewValue: 'Yearly' },
  ];
  modeList: any = ['invitation', 'instant'];
  productList: any = [];
  selectedProduct: string[] = [''];
  listOfSeoProjects: any = [];
  listOfSeoProjectsRAW: any = [];
  selectedSeoProjects: string[] = [''];
  productsLoading: boolean = true;
  selectedPrivileges: any;
  selectedStore: any;
  currentUserRoles: any;
  rolePageList: any;
  combinedRoleList: any;
  isMasterAcc: any;
  userTargets: any = this.localStorageService.get('shopId_list') || [];

  listOfAdsProjects: any = [];
  listOfAdsProjectsRAW: any = [];
  selectedAdsProjects: string[] = [];

  rolePrivilegeOrganizer: any = [
    {
      name: 'Nudge',
      roles: [
        'masterDashboard',
        'masterPreview',
        'masterFrequencies',
        'masterPerformanceOverall',
        'masterPerformanceOverview',
        'masterPerformanceDetailed',
        'masterLongitudinalOverall',
        'masterLongitudinalDetailed',
      ],
    },
    {
      name: 'Diagnostic',
      roles: [
        'bugTrackingOverall',
        'bugTrackingDetailed',
        'imageOptimization',
        'bugTrackingMenagement',
        'traceError',
      ],
    },
    {
      name: 'Recording',
      roles: ['recording_overall', 'recording_heatmap', 'recording_campaign'],
    },
    {
      name: 'Merchandise',
      roles: [
        'merchandising',
        'merchandising_products',
        'merchandising_categories',
      ],
    },
    {
      name: 'Organic',
      roles: [
        'seo_getting_started',
        'seo_overall',
        'seo_projects',
        'seo_pages',
        'seo_ai-analysis',
        'seo_backlinks',
        'seo_content',
        'seo_backlinks_prospect-analysis',
        'seo_backlinks_ai-profile',
        'seo_backlinks_backlinks-list',
        'seo_backlinks_anchors',
        'seo_backlinks_referring-ips',
        'seo_backlinks_referring-domains',
        'seo_position-tracking',
        'seo_technicals',
        'seo_social',
        'seo_on-page',
        'seo_automations',
        'seo_scripts',
        'userPermissions',
        'seo_billing',
        'seo_backlink_marketplace',
      ],
    },
    {
      name: 'Backlink Freelancer',
      roles: ['backlink_freelancer', 'backlink_freelancer_my-listings'],
    },
    {
      name: 'Marketing Officer',
      roles: [
        'seo_getting_started',
        'seo_overall',
        'seo_projects',
        'seo_pages',
        'seo_ai-analysis',
        'seo_backlinks',
        'seo_content',
        'seo_backlinks_prospect-analysis',
        'seo_backlinks_ai-profile',
        'seo_backlinks_backlinks-list',
        'seo_backlinks_anchors',
        'seo_backlinks_referring-ips',
        'seo_backlinks_referring-domains',
        'seo_position-tracking',
        'seo_technicals',
        'seo_social',
        'seo_on-page',
        'seo_automations',
        'seo_scripts',
        'userPermissions',
        'seo_billing',
      ],
    },
    {
      name: 'Automations',
      roles: ['automationsLibrary', 'automationsOverview'],
    },
    {
      name: 'Ad Copilot',
      roles: [
        'copilot_ads',
        'ads_projects',
        'ads_ai-audit',
        'ads_integrations',
        'ads_competitor',
      ],
    },
  ];

  isOrganicCategorySelected: boolean = false;
  isAdsCategorySelected: boolean = false;

  flowStatus = false;
  // isPrivilege = false;
  selectedTargets: string[] = [];

  isProcessing: boolean = false;

  autherizationProvider: any = [
    { value: 'local', viewValue: 'Local' },
    { value: 'microsoft', viewValue: 'Microsoft' },
  ];

  user_seo_roles: any = [];
  user_ads_roles: any = [];

  disable_product_selector: boolean = false;
  disable_seoProjects_selector: boolean = false;

  seo_roles: any = [];

  ads_projects: any;
  ads_roles: any;

  isBehamicsUser: boolean = false;
  isMaster: boolean = false;
  isWhiteLabel: boolean = false;
  isMasterRole: boolean = false;

  ngOnInit() {
    if (this.localStorageService.get('shopId_list')) {
      this.userTargets = this.localStorageService.get('shopId_list') || [];
    }

    if (this.isWhiteLabel) {
      this.isOrganicCategorySelected = true;
    }

    if (this.data.target) {
      this.selectedTargets = this.data.target.split(',');
    }

    this.user_seo_roles = this.localStorageService.get('seo_roles') || [];
    this.user_ads_roles = this.localStorageService.get('ads_roles') || [];

    this.selectedStore = this.coreTargetService.getSelectedTarget('target');

    // if (this.data.isPrivilegeEdit) {
    //   this.isPrivilege = true;
    //   this.getAvailableRoles();
    // } else {
    if (this.data.email != null) {
      this.getCurrentUserRoles();
      this.isNew = false;

      // const selectedSeoRole = this.user_seo_roles?.[0].role;

      this.form.setValue({
        name: this.data.name,
        email: this.data.email,
        role: '',
        seoProjects: '',
        product: '',
        targets: ['default_target_value'],
        adsProjects: '',
        adsRole: 'ads_manager',
        isMaster: false,
        // authProvider: this.data.authProvider,

        ...(this.isBehamicsUser || (this.isWhiteLabel && this.isMasterRole)
          ? {
              isPremiumSubscription: this.data.isPremiumSubscription || false,
              // billingInterval: this.data.billingInterval || '',
              // organicKeywordsNum: this.data.organicKeywordsNum || '',
              // price: this.data.price || 0,
              // forOrganic: this.data.forOrganic || false,
            }
          : {}),
      });

      this.form.get('email')?.disable();

      this.oldData = this.form.value;

      const valueChanges = this.form.valueChanges.subscribe((data) => {
        if (JSON.stringify(this.oldData) === JSON.stringify(this.form.value)) {
          this.formValueChanged = false;
        } else {
          this.formValueChanged = true;
        }
      });
      this.userActionsSub.add(valueChanges);

      if (this.data.bugSubscription == 'Premium') {
        this.flowStatus = true;
      }
    } else {
      // this.getAvailableRoles();
      this.isNew = true;
      this.form.setValue({
        name: '',
        email: '',
        product: '',
        seoProjects: '',
        role: '',
        targets: '',
        adsProjects: '',
        adsRole: 'ads_manager',
        isMaster: false,

        ...(this.isBehamicsUser || (this.isWhiteLabel && this.isMasterRole)
          ? {
              isPremiumSubscription: false,
              // billingInterval: '',
              // organicKeywordsNum: '',
              // price: 0,
              // forOrganic: false,
            }
          : {}),
      });
      this.form.patchValue({
        mode: 'invitation',
        role: 'user',
        adsRole: 'ads_manager',
        password: '1',
      });
    }

    const privileges = this.localStorageService.get('privileges');
    if (privileges) {
      this.checkAvailableProducts(privileges);
    }

    this.form.patchValue({
      targets: this.selectedStore,
    });

    this.form.get('targets')?.disable();

    const valueChanges = this.form.valueChanges.subscribe((data) => {
      if (data.role == 'user' || data.role == 'admin') {
        this.isMasterAcc = false;
      } else {
        this.isMasterAcc = true;
      }
    });
    this.userActionsSub.add(valueChanges);

    if (this.data.role == 'user' || this.data.role == 'admin') {
      this.isMasterAcc = false;
    } else {
      this.isMasterAcc = true;
    }

    this.userActionsSub.add(
      this.sidenavService.getAdsProjects().subscribe((projects: any) => {
        const user_ads_roles: any =
          this.localStorageService.get('user_ads_roles') || [];

        const allProjects = [...projects, ...user_ads_roles];

        // remove duplicates
        const uniqueProjects = allProjects.filter(
          (item: any, index: number) =>
            allProjects.findIndex(
              (t: any) => t.domain === item.domain && t.project === item.project
            ) === index
        );

        this.ads_projects = uniqueProjects;

        this.listOfAdsProjects = uniqueProjects.map((p: any) => ({
          project: p.project,
          domain: p.domain,
          customValue: `${p.project}__${p.domain}`.trim(),
        }));

        this.listOfAdsProjectsRAW = [...this.listOfAdsProjects];

        if (this.ads_projects?.length == 1) {
          this.selectedAdsProjects.push(this.listOfAdsProjects[0].customValue);
          const onlyValue = this.listOfAdsProjects[0].customValue;
          this.form
            .get('adsProjects')!
            .setValue([onlyValue], { emitEvent: false });
        }
      })
    );
    // }
  }
  ngOnDestroy(): void {
    this.userActionsSub?.unsubscribe();
  }

  checkAvailableProducts(res: any) {
    if (!res) return;

    let formattedProductList = [];
    let pushedValues = new Set();

    for (let i = 0; i < res.length; i++) {
      if (res[i].includes('seo_') && !pushedValues.has('Organic')) {
        formattedProductList.push('Organic');
        pushedValues.add('Organic');
      } else if (
        res[i].includes('erformanceOverall') &&
        !pushedValues.has('Nudge')
      ) {
        formattedProductList.push('Nudge');
        pushedValues.add('Nudge');
      } else if (
        res[i].includes('merchandising_') &&
        !pushedValues.has('Merchandise')
      ) {
        formattedProductList.push('Merchandise');
        pushedValues.add('Merchandise');
      } else if (
        res[i].includes('recording_') &&
        !pushedValues.has('Recording')
      ) {
        formattedProductList.push('Recording');
        pushedValues.add('Recording');
      } else if (
        res[i].includes('automationsLibrary') &&
        !pushedValues.has('Automations')
      ) {
        formattedProductList.push('Automations');
        pushedValues.add('Automations');
      } else if (
        res[i].includes('bugTrackingOverall') &&
        !pushedValues.has('Diagnostic')
      ) {
        formattedProductList.push('Diagnostic');
        pushedValues.add('Diagnostic');
      } else if (
        res[i].includes('copilot_ads') &&
        !pushedValues.has('Ad Copilot')
      ) {
        formattedProductList.push('Ad Copilot');
        pushedValues.add('Ad Copilot');
      } else if (
        res[i].includes('seo_backlink_marketplace') &&
        !pushedValues.has('Backlink Freelancer')
      ) {
        formattedProductList.push('Backlink Freelancer');
        pushedValues.add('Backlink Freelancer');
      }
    }

    this.productList = formattedProductList;

    this.disable_product_selector = false;
    if (this.productList?.length === 1) {
      this.selectedProduct = this.productList;
      this.form.patchValue({
        product: this.selectedProduct,
      });
      this.form.get('product')?.disable();

      this.isOrganicCategorySelected =
        this.selectedProduct?.includes('Organic');

      this.isAdsCategorySelected = this.selectedProduct?.includes('Ad Copilot');

      this.disable_product_selector = true;

      this.selectedProduct.forEach((value: any) => {
        const selectedCategory = this.rolePrivilegeOrganizer.find(
          (item: any) => item.name === value
        );

        if (
          selectedCategory &&
          selectedCategory.name !== 'Organic' &&
          selectedCategory.name !== 'Ad Copilot'
        ) {
          this.selectedPrivileges.push(...selectedCategory.roles);
        }

        if (value == 'Organic') {
          this.updateOrganicRoles(
            this.form.get('role')?.value,
            this.selectedPrivileges
          );
        }

        if (value == 'Ad Copilot') {
          this.updateAdsRoles(
            this.form.get('adsRole')?.value,
            this.selectedPrivileges
          );
        }
      });
      this.selectedPrivileges = [...new Set(this.selectedPrivileges)];
    }

    this.userActionsSub.add(
      this.seoService.getProjects().subscribe({
        next: (response: any) => {
          for (let i = 0; i < response.length; i++) {
            this.listOfSeoProjects.push(response[i].domain);
          }

          this.listOfSeoProjects = this.listOfSeoProjects.sort(
            (a: any, b: any) => a.localeCompare(b)
          );

          this.listOfSeoProjectsRAW = [...this.listOfSeoProjects];

          this.disable_seoProjects_selector = false;
        },
        error: (err: any) => {
          console.log(err);
        },
      })
    );

    this.productsLoading = false;

    this.priviledgeFormatter();
  }

  returnProductsFromPrivileges(privileges: string[]) {
    const products: string[] = [];
    const user_organic_roles: string[] = [];
    // let user_role: string = '';

    this.rolePrivilegeOrganizer.forEach((organizer: any) => {
      // If user has privileges of other products than 'Organic'
      if (organizer?.name != 'Organic' && !products.includes(organizer?.name)) {
        if (organizer.roles.some((role: string) => privileges.includes(role))) {
          products.push(organizer?.name);
        }
      } else if (organizer?.name == 'Organic') {
        organizer.roles.forEach((orgRole: string) => {
          if (privileges.includes(orgRole)) {
            user_organic_roles.push(orgRole);
          }
        });
      }
    });

    const organic_roles = this.rolePrivilegeOrganizer.find(
      (role: any) => role.name == 'Organic'
    ).roles;
    const seo_content_roles = this.roleList.find(
      (role: any) => role.value == 'seo_content_writer'
    ).privileges;

    if (user_organic_roles.length == seo_content_roles.length) {
      // user_role = 'seo_content_writer';
      products.push('Organic');
    } else if (user_organic_roles.length > 0) {
      const backlink_privileges_length = privileges.filter(
        (privilege: string) => privilege.includes('seo_backlinks')
      ).length;

      if (user_organic_roles.length == backlink_privileges_length) {
        // user_role = 'seo_backlink_provider';
        products.push('Organic');
      } else if (organic_roles.length > backlink_privileges_length) {
        // user_role = 'seo_manager';
        products.push('Organic');
      }
    }

    this.form.patchValue({
      product: products,
      // role: user_role,
    });
  }

  updateOrganicRoles(value: any, selectedPrivileges: any) {
    const organicRoles = this.rolePrivilegeOrganizer.find(
      (obj: any) => obj.name === 'Organic'
    )?.roles;

    const marketingOfficerRoles = this.rolePrivilegeOrganizer.find(
      (obj: any) => obj.name === 'Marketing Officer'
    )?.roles;

    if (value === 'seo_manager') {
      for (let i = 0; i < organicRoles.length; i++) {
        selectedPrivileges.push(organicRoles[i]);
      }
    } else if (value === 'seo_content_writer') {
      selectedPrivileges.push('seo_content');
      selectedPrivileges.push('seo_getting_started');
    } else if (value === 'seo_backlink_provider') {
      for (let i = 0; i < organicRoles.length; i++) {
        if (organicRoles[i].includes('seo_backlinks')) {
          selectedPrivileges.push(organicRoles[i]);
        }
      }
    } else if (value === 'marketing_officer') {
      for (let i = 0; i < marketingOfficerRoles.length; i++) {
        selectedPrivileges.push(marketingOfficerRoles[i]);
      }
    }
  }
  updateAdsRoles(value: any, selectedPrivileges: any) {
    const adsRoles = this.rolePrivilegeOrganizer.find(
      (obj: any) => obj.name === 'Ad Copilot'
    )?.roles;
    if (value === 'ads_manager') {
      for (let i = 0; i < adsRoles.length; i++) {
        selectedPrivileges.push(adsRoles[i]);
      }
    } else if (value === 'ads_content_writer') {
      selectedPrivileges.push('copilot_ads', 'ads_projects');
    }
  }

  priviledgeFormatter() {
    const organicRoles = this.rolePrivilegeOrganizer.find(
      (obj: any) => obj.name === 'Organic'
    )?.roles;
    const adsRoles = this.rolePrivilegeOrganizer.find(
      (obj: any) => obj.name === 'Ad Copilot'
    )?.roles;

    this.userActionsSub.add(
      this.form.get('product')?.valueChanges.subscribe((newValue) => {
        this.selectedPrivileges = [];
        if (newValue) {
          this.isOrganicCategorySelected = newValue.includes('Organic');
          this.isAdsCategorySelected = newValue.includes('Ad Copilot');

          newValue.forEach((value: any) => {
            const selectedCategory = this.rolePrivilegeOrganizer.find(
              (item: any) => item.name === value
            );

            if (selectedCategory && selectedCategory.name !== 'Organic') {
              this.selectedPrivileges.push(...selectedCategory.roles);
            }

            if (value == 'Organic') {
              this.updateOrganicRoles(
                this.form.get('role')?.value,
                this.selectedPrivileges
              );
            }

            if (value == 'Ad Copilot') {
              this.updateAdsRoles(
                this.form.get('adsRole')?.value,
                this.selectedPrivileges
              );
            }
          });

          this.selectedPrivileges = [...new Set(this.selectedPrivileges)];
        }

        if (this.productList?.length === 1) {
          this.productSelect?.close();
        }
      })
    );

    this.userActionsSub.add(
      // Listen to changes on the 'role' form control
      this.form.get('role')?.valueChanges.subscribe((newValue) => {
        if (this.selectedPrivileges) {
          for (let i = 0; i < this.selectedPrivileges.length; i++) {
            if (organicRoles.includes(this.selectedPrivileges[i])) {
              this.selectedPrivileges[i] = '';
            }
          }

          this.selectedPrivileges = this.selectedPrivileges.filter(
            (priv: any) => priv != ''
          );

          this.updateOrganicRoles(newValue, this.selectedPrivileges);
        }
      })
    );

    this.userActionsSub.add(
      this.form.get('adsRole')?.valueChanges.subscribe((newValue) => {
        if (this.selectedPrivileges) {
          for (let i = 0; i < this.selectedPrivileges.length; i++) {
            if (adsRoles.includes(this.selectedPrivileges[i])) {
              this.selectedPrivileges[i] = '';
            }
          }

          this.selectedPrivileges = this.selectedPrivileges.filter(
            (priv: any) => priv != ''
          );

          this.updateAdsRoles(newValue, this.selectedPrivileges);
        }
      })
    );

    this.userActionsSub.add(
      // Listen to changes on the 'role' form control
      this.form.get('seoProjects')?.valueChanges.subscribe((newValue) => {
        if (this.listOfSeoProjects?.length === 1) {
          this.seoProjectsSelect?.close();
        }
      })
    );

    this.userActionsSub.add(
      this.form.get('adsProjects')?.valueChanges.subscribe((newValue) => {
        if (this.listOfAdsProjects?.length === 1) {
          this.adsProjectsSelect?.close();
        }
      })
    );
  }

  getCurrentUserRoles() {
    const email =
      this.localStorageService.get('email') == 'master@behamics.com'
        ? this.data.email
        : this.localStorageService.get('email');

    const getCurrentUserRoles = this.service
      .getCurrentUserRoles(this.data.email)
      .subscribe({
        next: (res) => {
          const existingProjects = new Set(this.listOfSeoProjects);

          for (let i = 0; i < res.seo_roles.length; i++) {
            const project = res.seo_roles[i].project;
            if (
              !existingProjects.has(project) &&
              res.seo_roles[i].shopID === this.selectedStore
            ) {
              this.listOfSeoProjects.push(project);
            }
          }

          this.listOfSeoProjects = this.listOfSeoProjects.sort(
            (a: any, b: any) => a.localeCompare(b)
          );

          this.listOfSeoProjectsRAW = [...this.listOfSeoProjects];

          this.selectedSeoProjects = [];
          if (res?.seo_roles) {
            for (let i = 0; i < res.seo_roles.length; i++) {
              if (res.seo_roles[i].shopID === this.selectedStore) {
                this.selectedSeoProjects.push(res.seo_roles[i].project);
              }
            }
          }

          // if (
          //   this.selectedSeoProjects.length === 0 &&
          //   this.listOfSeoProjects.length > 0
          // ) {
          //   this.selectedSeoProjects.push(this.listOfSeoProjects[0]);
          // }

          this.currentUserRoles = res.privileges;

          const userProjects: string[] = [];
          const userAdsProjects: string[] = [];
          let selected_user_role = '';

          if (res?.seo_roles) {
            for (let i = 0; i < res?.seo_roles?.length; i++) {
              if (res.seo_roles[i].shopID === this.selectedStore) {
                userProjects.push(res?.seo_roles[i].project);
              }
            }

            selected_user_role = res?.seo_roles.find(
              (role: any) => role.shopID === this.selectedStore
            )?.role;
          }

          let selected_ads_role = '';
          if (res?.ads_roles) {
            res?.ads_roles.forEach((role: any) => {
              const customValue = `${role.project}__${role.domain}`.trim();

              if (
                role.shopID === this.selectedStore &&
                !userAdsProjects.includes(customValue)
              ) {
                userAdsProjects.push(customValue);
              }
            });

            selected_ads_role = res?.ads_roles.find(
              (role: any) => role.shopID === this.selectedStore
            )?.role;
          }

          this.form.patchValue({
            seoProjects: userProjects,
            role: selected_user_role,
            adsProjects: userAdsProjects,
            adsRole: selected_ads_role,
            ...(this.isWhiteLabel ? { isMaster: res?.role === 'master' } : {}),
          });

          const selectedProjectPriv = this.currentUserRoles.find(
            (store: any) => {
              return store.shopID == this.selectedStore;
            }
          ).priv;

          this.returnProductsFromPrivileges(selectedProjectPriv);
          // this.getAvailableRoles();
        },
        error: (err) => {
          // this.getAvailableRoles();
        },
      });
    this.userActionsSub.add(getCurrentUserRoles);
  }

  getAllRoles() {
    const getAllRoles = this.service.getRoleList().subscribe((res) => {
      if (res) {
        this.rolePageList = res;

        if (this.currentUserRoles != null) {
          for (var i = 0; i < this.rolePageList.length; i++) {
            for (var j = 0; j < this.currentUserRoles.length; j++) {
              if (this.rolePageList[i].value === this.currentUserRoles[j]) {
                this.rolePageList[i].checked = true;
                break;
              }
            }
          }
        }
      }
    });
    this.userActionsSub.add(getAllRoles);
  }

  // getAvailableRoles() {
  //   const getAvailableRoles = this.service.getRoles().subscribe((data) => {
  //     //this.roleList = data;
  //     if (!this.isNew) {
  //       // this.getAllRoles();
  //     }
  //   });
  //   this.userActionsSub.add(getAvailableRoles);
  // }

  addUser() {
    const selectedProducts = this.form.get('product')?.value;

    try {
      if (
        selectedProducts.includes('Organic') &&
        this.form.getRawValue()['seoProjects'].length > 0
      ) {
        this.seo_roles =
          this.user_seo_roles.filter((role: any) => {
            return (
              this.form
                .getRawValue()
                ?.['seoProjects']?.includes(role.project) &&
              this.selectedStore === role.shopID
            );
          }) || [];

        if (this.seo_roles?.length == 0) {
          const selectedProjects = this.form
            .getRawValue()
            ['seoProjects']?.filter((p: any) => p != '');

          for (let i = 0; i < selectedProjects.length; i++) {
            this.seo_roles.push({
              project: selectedProjects[i],
              role: this.form.getRawValue()['role'],
              shopID: this.selectedStore,
            });
          }
        } else {
          for (let i = 0; i < this.seo_roles.length; i++) {
            this.seo_roles[i].role = this.form.getRawValue()['role'];
          }
        }
      }
    } catch (e) {
      console.log(e);
    }

    try {
      if (selectedProducts.includes('Ad Copilot')) {
        this.ads_roles =
          this.user_ads_roles.filter((role: any) => {
            return (
              this.form
                .getRawValue()
                ?.['adsProjects']?.includes(role.project) &&
              this.selectedStore === role.shopID
            );
          }) || [];

        if (this.ads_roles?.length == 0) {
          const selectedProjects = this.form
            .getRawValue()
            ['adsProjects']?.filter((p: any) => p != '');

          for (let i = 0; i < selectedProjects.length; i++) {
            const [project, domain] = selectedProjects[i].split('__');

            this.ads_roles.push({
              project: project,
              domain: domain,
              role: this.form.getRawValue()['adsRole'],
              shopID: this.selectedStore,
            });
          }
        } else {
          for (let i = 0; i < this.ads_roles.length; i++) {
            this.ads_roles[i].role = this.form.getRawValue()['adsRole'];
          }
        }
      }
    } catch (e) {
      console.log(e);
    }

    try {
      if (
        selectedProducts.includes('Organic') &&
        this.form.getRawValue()['seoProjects'].length == 0
      ) {
        this.updateOrganicRoles('seo_manager', this.selectedPrivileges);
      }
    } catch (e) {
      console.log(e);
    }

    const seoSubscription = this.localStorageService.get('seoSubscription');

    const paramObj = {
      name: this.form.getRawValue()['name'],
      email: this.form.getRawValue()['email']?.toLowerCase(),
      target: this.selectedStore,
      role:
        this.isWhiteLabel && this.form.getRawValue()['isMaster']
          ? 'master'
          : 'sub-master',
      authProvider: 'local',
      privileges: this.selectedPrivileges,
      shopID: this.selectedStore,
      seo_roles: this.seo_roles,
      ...(this.ads_roles?.length > 0 ? { ads_roles: this.ads_roles } : {}),

      ...(this.localStorageService.get('adsSubscription')
        ? { adsSubscription: this.localStorageService.get('adsSubscription') }
        : {}),

      ...(seoSubscription ? { seoSubscription: seoSubscription } : {}),

      ...(this.localStorageService.get('customerId')
        ? { customerId: this.localStorageService.get('customerId') }
        : {}),
      ...(this.isBehamicsUser || (this.isWhiteLabel && this.isMasterRole)
        ? {
            seoSubscription:
              this.form.getRawValue()['isPremiumSubscription'] &&
              !this.data?.stripeConfig
                ? 'Premium'
                : 'Freemium',
          }
        : {}),
    };

    this.isProcessing = true;
    const createUser = this.service.inviteUser(paramObj).subscribe({
      next: (data) => {
        this.isProcessing = false;
        if (data.status == 400) {
          this.getTranslatedText(
            'a_user_with_this_email_already_exists',
            'phrases'
          ).subscribe((translatedText) => {
            this.notificationService.warn(translatedText);
          });
        } else {
          if (data.mode == 'invitation') {
            this.dialogRef.close('invited');
          } else {
            this.dialogRef.close('added');
          }
        }
      },
      error: (err) => {
        this.isProcessing = false;
        this.getTranslatedText('something_went_wrong', 'phrases').subscribe(
          (translatedText) => {
            this.notificationService.error(translatedText);
          }
        );
        console.log(err);
      },
    });
    this.userActionsSub.add(createUser);
  }

  isMasterCheckboxChange(event: any) {
    this.form.get('isMaster')?.setValue(event.checked);
  }

  editUser() {
    const selectedProjects = this.form.getRawValue()['seoProjects'];

    this.seo_roles = this.user_seo_roles.filter((role: any) => {
      return (
        selectedProjects.includes(role.project) &&
        this.selectedStore === role.shopID
      );
    });

    const existingProjectRoles = this.seo_roles.map(
      (role: any) => role.project
    );

    for (let i = 0; i < selectedProjects.length; i++) {
      const project = selectedProjects[i];
      if (!existingProjectRoles.includes(project)) {
        this.seo_roles.push({
          project: project,
          role: this.form.getRawValue()['role'],
          shopID: this.selectedStore,
        });
      }
    }

    if (this.form.get('role')?.value) {
      this.seo_roles.forEach((tmp: any) => {
        tmp['role'] = this.form.get('role')?.value;
      });
    }

    const selectedAdsProjects = this.form.getRawValue()['adsProjects'];

    this.ads_roles = this.user_ads_roles.filter((role: any) => {
      return (
        selectedAdsProjects.includes(role.project) &&
        this.selectedStore === role.shopID
      );
    });

    const existingAdsProjectRoles = this.ads_roles.map(
      (role: any) => role.project
    );

    for (let i = 0; i < selectedAdsProjects.length; i++) {
      const [project, domain] = selectedAdsProjects[i].split('__');
      if (!existingAdsProjectRoles.includes(project)) {
        this.ads_roles.push({
          project: project,
          domain: domain,
          role: this.form.getRawValue()['adsRole'],
          shopID: this.selectedStore,
        });
      }
    }

    if (this.form.get('adsRole')?.value) {
      this.ads_roles.forEach((tmp: any) => {
        tmp['role'] = this.form.get('adsRole')?.value;
      });
    }

    const paramObj = {
      name: this.form.getRawValue()['name'],
      email: this.form.getRawValue()['email']?.toLowerCase(),
      oldEmail: this.oldData.email,
      role:
        this.isWhiteLabel && this.form.getRawValue()['isMaster']
          ? 'master'
          : 'sub-master',
      shopID: this.selectedStore,
      authProvider: 'local',
      seo_roles: this.seo_roles,
      ads_roles: this.ads_roles,
      privileges: this.selectedPrivileges,
      ...(this.localStorageService.get('customerId')
        ? { customerId: this.localStorageService.get('customerId') }
        : {}),

      ...(this.isBehamicsUser || (this.isWhiteLabel && this.isMasterRole)
        ? {
            seoSubscription:
              this.form.getRawValue()['isPremiumSubscription'] &&
              !this.data?.stripeConfig
                ? 'Premium'
                : 'Freemium',
          }
        : {}),
    };

    this.isProcessing = true;
    const editUser = this.service
      .clientUpdateUser(paramObj)
      .subscribe((data) => {
        this.isProcessing = false;
        this.dialogRef.close('updated');
      });
    this.userActionsSub.add(editUser);
  }
  getTranslatedText(text: string, type: string = 'words'): Observable<string> {
    return this.translate.get(`${type}.${text}`).pipe(
      map((translated: string) =>
        translated === `${type}.${text}` ? text : translated
      ),
      catchError(() => of(text))
    );
  }
  isFormValid(isEdit: boolean = false) {
    if (
      (isEdit && this.form.pristine) ||
      !this.form.valid ||
      this.isProcessing ||
      (this.form.getRawValue()['product'].includes('Organic') &&
        this.form.getRawValue()['role'] == 'user' &&
        this.form.getRawValue()['seoProjects'].length > 0)
      //    ||
      // (this.form.getRawValue()['product'].includes('Ad Copilot') &&
      //   (this.form.getRawValue()['adsRole'] == 'user' ||
      //     this.form.getRawValue()['adsRole'] == ''))
    ) {
      return false;
    }
    return true;
  }
}
